import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Dashboard from "./pages/DashboardPage";
import { AuthProvider } from "./context/AuthContext";
import { BrandingProvider } from "./context/BrandingContext";
// import Layout from "./layout/layout";
// import Test from "./pages/Test";
import { Provider } from "react-redux";
import { store } from "./config/store/store";
import { blokkoTheme } from './theme/theme';

const App = () => {
  return (
    <ThemeProvider theme={blokkoTheme}>
      <CssBaseline />
      <Provider store={store}>
        <AuthProvider>
          <BrandingProvider>
            {/* <Layout> */}
            <Router>
              <Switch>
                {/* redirect to dashboard if the route is / */}
                <Redirect exact from="/" to="/dashboard" />
                <Route path="/dashboard" component={Dashboard} />
                {/* <Route path="/dashboard" component={Test} /> */}
              </Switch>
            </Router>
            {/* </Layout> */}
          </BrandingProvider>
        </AuthProvider>
      </Provider>
    </ThemeProvider>
  );
};

export default App;
